import axios from 'axios';
import { config } from '../config';

const API_BASE_URL = config.API_URL;

export const getAuthHeaders = (tenantId) => {
  const headers = {};
  const token = localStorage.getItem('token');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  if (tenantId) {
    headers['x-tenant-id'] = tenantId;
  }
  return headers;
};

export const api = {
  get: async (endpoint, tenantId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${endpoint}`, {
        headers: getAuthHeaders(tenantId)
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        // Server hat geantwortet mit einem Status-Code außerhalb von 2xx
        throw error;
      } else if (error.request) {
        // Request wurde gemacht, aber keine Antwort erhalten
        throw new Error('Keine Verbindung zum Server');
      } else {
        // Fehler beim Setup des Requests
        throw error;
      }
    }
  },

  post: async (endpoint, data, tenantId) => {
    try {
      const response = await axios.post(`${API_BASE_URL}${endpoint}`, data, {
        headers: getAuthHeaders(tenantId),
        maxContentLength: Infinity,
        maxBodyLength: Infinity
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error;
      } else if (error.request) {
        throw new Error('Keine Verbindung zum Server');
      } else {
        throw error;
      }
    }
  },

  put: async (endpoint, data, tenantId) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${endpoint}`, data, {
        headers: getAuthHeaders(tenantId),
        maxContentLength: Infinity,
        maxBodyLength: Infinity
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error;
      } else if (error.request) {
        throw new Error('Keine Verbindung zum Server');
      } else {
        throw error;
      }
    }
  },

  delete: async (endpoint, tenantId) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}${endpoint}`, {
        headers: getAuthHeaders(tenantId)
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error;
      } else if (error.request) {
        throw new Error('Keine Verbindung zum Server');
      } else {
        throw error;
      }
    }
  }
};

